document.addEventListener('DOMContentLoaded', () => {
  const saleDeadlineEls = document.querySelectorAll('[data-offer-sale-deadline]');

  if (!saleDeadlineEls.length) {
    return;
  }

  const now = new Date();
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  const dateString = now.toLocaleDateString(undefined, options);

  saleDeadlineEls.forEach((el) => {
    el.textContent = `Sale Ends Today, ${dateString} at 23:59`;
  });
});
